<div class="sch-input">
    <label *ngIf="label && variant === textboxVariants.CLASSIC" class="sch-input-label {{variant}}" for="{{ id }}"
        [attr.readonly]="readonly" [attr.disabled]="disabled">
        {{ label }}
    </label>

    <div class="position-relative">
        <input type="text" class="sch-input-field {{variant}} cursor-pointer" id="{{ id }}" [value]="selectedLabel"
            [placeholder]="readonly ? readonlyplaceholder : placeholder" 
            (input)="editable ? onInput($event) : null"
            (click)="readonly || disabled ? null : toggleDropdown()"
            [readonly]="readonly || !editable"
            [disabled]="disabled" [class.has-value]="selectedLabel" [class.has-placeholder]="placeholder"
            [autocomplete]="autocomplete" />

        <label *ngIf="label && variant !== textboxVariants.CLASSIC" class="sch-input-label {{variant}}" for="{{ id }}"
            [attr.readonly]="readonly" [attr.disabled]="disabled">
            {{ label }}
        </label>

        <seech-shared-spinner [color]="'primary'" *ngIf="isContentLoading" size="20px" [strokeWidth]="1"
            class="sch-input-icon" />

        <i *ngIf="!isContentLoading && !readonly" [id]="id" [sch-icon]="showDropdown ? 'expand' : 'collapse'"
            class="sch-input-icon sch-select-icn cursor-pointer"
            (click)="readonly || disabled ? null : toggleDropdown()"></i>
    </div>

    <div *ngIf="!(readonly && disabled) && showDropdown" class="sch-select-dropdown"
        #dropdownMenu sch-scroll-end-notifier [offset]="threshold" (scrollEnd)="onScrollEnd()" role="listbox">
        
        <!-- Search input inside dropdown -->
        <div *ngIf="!disableSearch" class="sch-select-search-container">
            <input 
                type="text" 
                class="sch-select-search-input"
                #searchInput
                [placeholder]="'Search ...'"
                (input)="onSearchInput($event)"
                (click)="$event.stopPropagation()"
                [autocomplete]="autocomplete"
            />
            <i sch-icon="search" class="sch-select-search-icon"></i>
        </div>
        <ng-container *ngFor="let option of filteredOptions; index as i">
            <div class="option-group" role="group" [attr.aria-label]="option.title">
                <div *ngIf="option.title" class="option-title">
                    {{ option.title }}
                </div>

                <ng-container *ngIf="option.options">
                    <ng-container *ngFor="let nestedOption of option.options">
                        <div *ngIf="!(!showSelected && selectedValue === nestedOption.value) && !nestedOption.hideOption"
                            class="sch-select-option" 
                            [ngClass]="{ active: selectedValue === nestedOption.value }"
                            (click)="selectOption(nestedOption)"
                            role="option"
                            [attr.aria-selected]="selectedValue === nestedOption.value"
                            tabindex="0">
                            <div class="sch-option-key">{{ nestedOption.label }}</div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>
